import ApiService from './ApiService';
import queryString from 'query-string';

export async function apiCalculateBasket(data) {
  return ApiService.fetchData({
    url: `Discount/CalculateForCustomer`,
    method: 'post',
    data,
  });
}

export async function apiIsCouponActive(data) {
  return ApiService.fetchData({
    url: `Discount/IsCouponApply?${queryString.stringify(data, {
      skipNull: true,
    })}`,
    method: 'get',
  });
}

export async function apiCreateOrder(data) {
  return ApiService.fetchData({
    url: `Order/CreateOrderForCustomer`,
    method: 'post',
    data,
  });
}

export async function apiRequestPayment(data) {
  return ApiService.fetchData({
    url: `Order/ChargeRequest?${queryString.stringify(data, {
      skipNull: true,
    })}`,
    method: 'post',
  });
}

export async function apiFinalizePayment(data) {
  return ApiService.fetchData({
    url: `Order/FinalizePayment?${queryString.stringify(data, {
      skipNull: true,
    })}`,
    method: 'post',
  });
}

// Spec 2026-09-12 §5.1: once the card is known and before it is confirmed,
// the API re-prices the Connect application fee from the card's country.
// Query string like the other payment calls; exactly one of paymentmethodid
// / confirmationtokenid. Silent: a refusal is "confirm with the estimate".
export async function apiConnectFeeQuote(data) {
  return ApiService.fetchData({
    url: `Order/ConnectFeeQuote?${queryString.stringify(data, {
      skipNull: true,
    })}`,
    method: 'post',
    silent: true,
  });
}
